// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_js-6";
export var emphasizeQuantity = "_js-3";
export var flatBottomCorners = "_js-5";
export var productImage = "_js-0";
export var quantityContainer = "_js-2";
export var tooltip = "_js-1";
export var wrapAndEllipsesOverflow = "_js-4";